module.exports = __webpack_public_path__ + "static/kingston-difference@large-31c41eb84cb969a6821477f6ecdef27e.jpg";